<template>
    <div v-if="bestsellers.length" class="category-bestseller">
        <h3 class="section-title mt-0 mb-4">Бестселлеры</h3>
        <carousel classes="bestseller-carousel slides-4" :items="bestsellers" :options="options" :show-navigation="showNavigation" :change-overflow="true">
            <template #slide="{ item }">
                <card :product="item"></card>
            </template>
        </carousel>
        <div class="bestsellers-separator"></div>
    </div>
</template>

<script>
    import Carousel from "../Carousel/Carousel";
    import { mapState } from "vuex";

    export default {
        name: 'Bestsellers',
        components: {
            Carousel
        },
        data() {
            return {
                options: {
                    loop: true,
                    spaceBetween: 5,
                    breakpoints: {
                        1200: {
                            slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        640: {
                            slidesPerView: 3,
                        },
                        576: {
                            slidesPerView: 3,
                        },
                        320: {
                            slidesPerView: 2,
                        }
                    },
                },
            }
        },
        computed: {
            ...mapState('catalog', [
                'bestsellers',
            ]),
            showNavigation() {
                return !((this.windowWidth <= 640 && this.bestsellers.length <= 1)
                    || (this.windowWidth <= 768 && this.bestsellers.length <= 2)
                    || (this.windowWidth <= 1024 && this.bestsellers.length <= 3)
                    || (this.windowWidth > 1024 && this.bestsellers.length <= 4)
                );
            }
        },
    }
</script>
